import React from "react";
import { Formik, Form, Field } from "formik";
import { NavLink } from "react-router-dom";
import { Button, InputGroup } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getPhoneExampleForCountry } from "../../../helpers/phoneHelper";
import SocialAuth from "./social-auth";

const Signup = (props) => {
  const {
    validationSchema,
    inputChange,
    handleGoogleSignup,
    handleMicrosoftSignup,
    isSocialLoading,
    searchTerm,
    searchTermone,
    searchTermtwo,
    selectedCountry,
    selectedstateone,
    selectedcity,
    hidefield,
    hidestate,
    hidecity,
    handleCountryChange,
    handleCountry,
    handleCountryChangestate,
    handleCountryChangecity,
    getState,
    getcity,
    userDatahandler,
    fullnameRef,
    emailRef,
    passwordRef,
    phonenumberRef,
    dobRef,
    country,
    handleState,
    handleCity,
    handleShow,
    setHidefield,
    setHidestate,
    setHidecity,
    setShowPassword,
    setChangeicon,
    changeicon,
    showPassword,
  } = props;

  return (
    <Formik
      initialValues={{
        fullname: "",
        email: "",
        password: "",
        phonenumber: "",
        country: "",
        state: "",
        city: "",
        dob: "",
        gender: "",
        acceptTerms: false,
      }}
      validateOnBlur={false}
      validationSchema={validationSchema}
      onSubmit={() => { }}
    >
      {({ handleChange, handleBlur, handleSubmit, errors, touched, isValid, dirty, values, setFieldValue }) => (
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <input type="text" style={{ display: "none" }} autoComplete="off" />
          <div className="row">
            <div className="col-md-6 mt-2">
              <label htmlFor="inputFullName" className="form-label labelSize">
                Full Name*
              </label>
              <Field
                type="text"
                className="form-control box-height inputSizing"
                placeholder="Full Name"
                id="inputFullName"
                name="fullname"
                autoComplete="off"
                innerRef={fullnameRef}
                onChange={(e) => {
                  inputChange(e);
                  handleChange(e);
                }}
                onBlur={handleBlur}
                onFocus={(e) => (e.target.value = "")}
              />
              {errors.fullname && touched.fullname ? (
                <div>
                  <p className="error_text_color">{errors.fullname}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputEmail" className="form-label labelSize">
                Email address*
              </label>
              <Field
                type="email"
                name="email"
                className="form-control box-height inputSizing"
                placeholder="Email address"
                id="inputEmail"
                autoComplete="off"
                innerRef={emailRef}
                onChange={(e) => {
                  inputChange(e);
                  handleChange(e);
                }}
                onBlur={handleBlur}
                onFocus={(e) => (e.target.value = "")}
              />
              {errors.email && touched.email ? (
                <div>
                  <p className="error_text_color">{errors.email}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputPassword" className="form-label labelSize">
                Password*
              </label>
              <InputGroup style={{ flexWrap: "nowrap" }} className="form-control box-height inputSizing">
                <Field
                  name="password"
                  type={showPassword}
                  className="border-0 password-width-signup p-0"
                  placeholder="Password"
                  autoComplete="new-password"
                  innerRef={passwordRef}
                  onChange={(e) => {
                    inputChange(e);
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  onFocus={(e) => (e.target.value = "")}
                />
                {changeicon === 1 && (
                  <VisibilityIcon
                    className="cursor_P"
                    onClick={() => {
                      setShowPassword("text");
                      setChangeicon(2);
                    }}
                  />
                )}
                {changeicon === 2 && (
                  <VisibilityOffIcon
                    className="cursor_P"
                    onClick={() => {
                      setShowPassword("password");
                      setChangeicon(1);
                    }}
                  />
                )}
              </InputGroup>
              {errors.password && touched.password ? (
                <div>
                  <p className="error_text_color">{errors.password}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputPhoneNumber" className="form-label labelSize">
                Phone Number*
              </label>
              <Field
                type="tel"
                className="form-control box-height inputSizing pb-3"
                placeholder={getPhoneExampleForCountry(selectedCountry)}
                name="phonenumber"
                autoComplete="off"
                innerRef={phonenumberRef}
                onChange={(e) => {
                  inputChange(e);
                  handleChange(e);
                }}
                onBlur={handleBlur}
                onFocus={(e) => (e.target.value = "")}
              />
              {errors.phonenumber && (touched.phonenumber || values.phonenumber) ? (
                <div>
                  <p className="error_text_color">{errors.phonenumber}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputCountry" className="form-label labelSize">
                Country*
              </label>
              <div className="blood-type p-0">
                <select
                  onClick={() => setHidefield(1)}
                  value={selectedCountry}
                  onChange={(e) => {
                    handleCountryChange(e);
                    handleCountry(e);
                    inputChange(e);
                    handleChange(e);
                    setFieldValue("state", "");
                    setFieldValue("city", "");
                  }}
                  className="b-radius selectSize w-100   inputSizing"
                  name="country"
                  autoComplete="off"
                >
                  {hidefield && <option>Select country</option>}
                  {country
                    .filter((country) => country.toLowerCase().includes((searchTerm || "").toLowerCase()))
                    .map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                </select>
              </div>
              {errors.country && touched.country ? (
                <div>
                  <p className="error_text_color">{errors.country}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputState" className="form-label labelSize">
                State*
              </label>
              <div className="blood-type p-0">
                <select
                  onClick={() => setHidestate(1)}
                  className="b-radius selectSize w-100  inputSizing"
                  value={selectedstateone}
                  aria-label="Default select example"
                  name="state"
                  autoComplete="off"
                  onChange={(e) => {
                    inputChange(e);
                    handleChange(e);
                    handleState(e);
                    handleCountryChangestate(e);
                    setFieldValue("city", "");
                  }}
                >
                  {hidestate && <option>Select state</option>}
                  {getState &&
                    getState
                      .filter((state) => state.toLowerCase().includes((searchTermone || "").toLowerCase()))
                      .map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                </select>
              </div>
              {errors.state && touched.state ? (
                <div>
                  <p className="error_text_color">{errors.state}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputCity" className="form-label labelSize">
                City
              </label>
              <div className="blood-type p-0">
                <select
                  onClick={() => setHidecity(1)}
                  value={selectedcity}
                  className="b-radius selectSize w-100  inputSizing"
                  aria-label="Default select example"
                  name="city"
                  autoComplete="off"
                  onChange={(e) => {
                    inputChange(e);
                    handleChange(e);
                    handleCountryChangecity(e);
                    if (handleCity) {
                      handleCity(e);
                    }
                  }}
                >
                  {hidecity && <option>Select city</option>}
                  {getcity &&
                    getcity
                      .filter((city) => (city.name || "").toLowerCase().includes((searchTermtwo || "").toLowerCase()))
                      .map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                </select>
              </div>
              {errors.city && touched.city ? (
                <div>
                  <p className="error_text_color">{errors.city}</p>
                </div>
              ) : null}
            </div>

            <div className="col-md-6 mt-2">
              <label htmlFor="inputDob" className="form-label labelSize">
                Date of birth*
              </label>
              <Field
                type="date"
                className="form-control box-height inputSizing"
                placeholder="Date of birth"
                name="dob"
                autoComplete="off"
                innerRef={dobRef}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => {
                  if (e.target.value) {
                    const selectedDate = new Date(e.target.value);
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    
                    if (selectedDate > currentDate) {
                      e.target.value = ""; // Clear future dates
                    }
                  }
                  inputChange(e);
                  handleChange(e);
                }}
                onBlur={handleBlur}
                onFocus={(e) => (e.target.value = "")}
              />
              {errors.dob && touched.dob ? (
                <div>
                  <p className="error_text_color">{errors.dob}</p>
                </div>
              ) : null}
            </div>

            <div className="row">
              <div className="col-6">
                <label htmlFor="inputGender" className="form-label labelSize pt-3">
                  Gender
                </label>
                <div className="col-md-10 pb-3 ps-0 pe-0">
                  <div className="form-check form-check-inline me-lg-4">
                    <Field
                      className="form-check-input mt-1"
                      type="radio"
                      id="inlineRadio1"
                      value="Male"
                      name="gender"
                      onChange={(e) => {
                        inputChange(e);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                    />
                    <label className="form-check-label radio labelSize form-label" htmlFor="inlineRadio1">
                      Male
                    </label>
                  </div>
                  <div className="form-check form-check-inline me-lg-4">
                    <Field
                      className="form-check-input mt-1"
                      type="radio"
                      id="inlineRadio2"
                      value="Female"
                      name="gender"
                      onChange={(e) => {
                        inputChange(e);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                    />
                    <label className="form-check-label radio labelSize form-label" htmlFor="inlineRadio2">
                      Female
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <Field
                      className="form-check-input mt-1"
                      type="radio"
                      id="inlineRadio3"
                      value="Other"
                      name="gender"
                      onChange={(e) => {
                        inputChange(e);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                    />
                    <label className="form-check-label radio form-label labelSize" htmlFor="inlineRadio3">
                      Other
                    </label>
                  </div>
                </div>
              </div>
              {errors.gender && touched.gender ? (
                <div>
                  <p className="error_text_color">{errors.gender}</p>
                </div>
              ) : null}
              <div className="form-check d-flex justify-content-center col-6 align-items-center">
                <Field
                  className="form-check-input"
                  type="checkbox"
                  name="acceptTerms"
                  onChange={(e) => {
                    inputChange(e);
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                />
                <label className="form-check-label radio form-label labelSize mb-0 mt-2 ms-1" htmlFor="flexCheckDisabled">
                  <a className="cur-pointer" onClick={handleShow}>
                    I agree to terms & conditions
                  </a>
                </label>
              </div>
              {errors.acceptTerms && touched.acceptTerms ? (
                <div>
                  <p className="error_text_color">{errors.acceptTerms}</p>
                </div>
              ) : null}
            </div>

            <div
              className="d-grid col-12"
              data-title={!(isValid && dirty) ? "Please fill out all Fields to enable button!" : null}
            >
              <Button
                onClick={(e) => userDatahandler(e)}
                disabled={!(isValid && dirty)}
                type="submit"
                className="disable-btn text-white w-100 p-3"
                style={{
                  backgroundColor: "#020094",
                  pointerEvents: !(isValid && dirty) ? "none" : "auto",
                }}
              >
                Sign Up
              </Button>
            </div>
            <SocialAuth
              handleGoogleSignup={handleGoogleSignup}
              handleMicrosoftSignup={handleMicrosoftSignup}
              isSocialLoading={isSocialLoading}
            />
            <div className="text-center pt-3 fs-7">
              <div>
                <NavLink to="/login">
                  <span style={{ color: "black" }}>Have a Account ?</span>
                  <span style={{ color: "#0b58ca", fontWeight: "500" }}> Login</span>
                </NavLink>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Signup;
